import { toast } from 'sonner';

import { hasActiveCall, isActiveMuted, setMuted } from '../device/session-device';

/**
 * Flip mute on the live SDK leg. Surfaces a toast instead of silently
 * no-oping when no leg is connected — the old silent path made a dead mute
 * button indistinguishable from a working one.
 */
export function toggleActiveMute(): boolean {
    const ok = hasActiveCall() && setMuted(!isActiveMuted());
    if (!ok) toast.error('Mute unavailable — call audio is not connected yet.');
    return ok;
}
